import { Checkbox, FormControlLabel, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";


export default function MainCheckbox(props) {
    const { label, type = "success", checked, onChange } = props;
    const { mode } = useColorScheme();
    var color = Constants.Colors[mode].accent;
    switch (type) {
        case "success":
            color = Constants.Colors[mode].accent;
            break;
        case "error":
            color = Constants.Colors[mode].error;
            break;
        case "warning":
            color = Constants.Colors[mode].warning;
            break;
        case "info":
            color = Constants.Colors[mode].info;
            break;
        case "default":
            color = Constants.Colors[mode].primary;
            break;
        default:
            break;
    }


    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            justifyContent={"start"}
        >
            <Checkbox
                checked={checked}
                onChange={onChange}
                sx={{
                    color: color,
                    '&.Mui-checked': {
                        color: color,
                    },
                    padding: 0,
                }}
            />
            <Typography variant="body2" align="center" mt={0.3}>{label}</Typography>
        </Stack>
    );
}